//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      options: {},
    };
  },
  mounted() {
    this.options = {
      color: ["#FFC793", "#DA302A"],
      grid: {
        top: 48,
        left: 0,
        right: 0,
        bottom: 20,
      },
      tooltip: {
        show: true,
        trigger: "axis",
        formatter: "{b}月<br />{a0}：{c0}<br />{a1}：{c1}",
      },
      legend: {
        right: 10,
        orient: "vertical",
        icon: "rect",
        itemWidth: 28,
        itemHeight: 2,
        textStyle: {
          color: "#666666",
          fontWeight: "bold",
        },
      },
      xAxis: {
        type: "category",
        data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        boundaryGap: [1, 1],
        axisLine: {
          lineStyle: {
            color: "rgb(132, 77, 26, 0.5)",
          },
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: "#844D1A",
          },
        },
        axisLabel: {
          interval: 0,
          color: "#333333",
        },
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "rgb(132, 77, 26, 0.1)",
          },
        },
      },
      series: [
        {
          name: "同比",
          type: "line",
          data: [20, 30, 50, 94, 78, 70, 40, 70, 84, 34, 86, 105],
          smooth: true,
          itemStyle: {
            opacity: 0,
          },
        },
        {
          name: "客流",
          type: "line",
          data: [70, 40, 70, 84, 34, 20, 30, 50, 94, 78, 106, 45],
          smooth: true,
          itemStyle: {
            opacity: 0,
          },
        },
      ],
    };
  },
};
